module.exports = __webpack_public_path__ + "static/mngYusaku-66dfc0639fae88990af58178aebb11fc.jpg";